import { inject } from './inject';
import { PciProxyCvv as BasePciProxyCvv } from './PciProxyCvv';

export const PciProxyCvv = inject(BasePciProxyCvv);
